var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineNoQuickMessages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "55px",
    viewBox: "0 0 84 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lineNoQuickMessages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quick-reply---EMPTY-STATES",
    transform: "translate(-266.000000, -548.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lineNoQuickMessages",
    transform: "translate(266.000000, 534.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97011087,78.6280852 C59.3737409,63.8069962 78.4490313,40.2030397 67.1959823,7.81621556",
    stroke: "#7EC34D",
    strokeWidth: 1.5,
    transform: "translate(40.148799, 43.222150) rotate(18.000000) translate(-40.148799, -43.222150) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,18 L77,14.5 L83.9504856,27.9616128 L77,18 Z M77,18 L70.0495144,27.9616128 L77,14.5 L77,18 Z",
    id: "Combined-Shape",
    fill: "#7EC34D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineNoQuickMessages);
export default __webpack_public_path__ + "static/media/lineNoQuickMessages.4b0a84101b8922714491245aa48afe1e.svg";
export { ForwardRef as ReactComponent };